import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import {urlWMSLastebd, formatoPNG} from './configuracion';

const layer03 = new TileLayer({
    title: 'Cultivo Arrozal',
    source: new TileWMS({
      url: urlWMSLastebd,
      params: {LAYERS: 'arrozal', format: formatoPNG},
      gutter: 200,
    })
  });
  layer03.setVisible(false);

const layer04 = new TileLayer({
    title: 'Marisma',
    source: new TileWMS({
      url: urlWMSLastebd,
      params: {LAYERS: 'marisma', format: formatoPNG},
      gutter: 200,
    })
  });
  layer04.setVisible(false);

const layer04_1 = new TileLayer({
    title: 'Toponimia',
    source: new TileWMS({
      url: urlWMSLastebd,
      params: {LAYERS: 'toponimia', format: formatoPNG},
      gutter: 200,
    })
  });
  layer04_1.setVisible(false);


const layer08A = new TileLayer({
  title: 'Parcelas Censo Terrestre',
  source: new TileWMS({
    url: urlWMSLastebd,
    params: {LAYERS: 'parcelas_censo_terrestre', format: formatoPNG},
    gutter: 200,
  })
});
layer08A.setVisible(false);
  
const layer08B = new TileLayer({
  title: 'Parcelas Censo Aereo desde 2013',
  source: new TileWMS({
    url: urlWMSLastebd,
    params: {LAYERS: 'parcelas_censo_aereo_desde_2013', format: formatoPNG},
    gutter: 200,
  })
});
layer08B.setVisible(false);
  
const layer08C = new TileLayer({
  title: 'Parcelas Censo Aereo antes 2013',
  source: new TileWMS({
    url: urlWMSLastebd,
    params: {LAYERS: 'parcelas_censo_aereo_anterior_2013', format: formatoPNG},
    gutter: 200,
  })
});
layer08C.setVisible(false);

export const grupoCapa02 = new LayerGroup({
  title: 'Capas de Identificación',
  fold: 'close',
  layers: [layer03, layer04, layer04_1, layer08A, layer08B, layer08C,]
});